import { render, staticRenderFns } from "./jng_wx_user.vue?vue&type=template&id=f3d700e8&scoped=true&"
import script from "./jng_wx_user.vue?vue&type=script&lang=js&"
export * from "./jng_wx_user.vue?vue&type=script&lang=js&"
import style0 from "./jng_wx_user.vue?vue&type=style&index=0&id=f3d700e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d700e8",
  null
  
)

export default component.exports